import { appStore } from "@/app/store/appStore";


export function setAuthToken(token: string|null): void {
	appStore.getState().setAuthToken(token);
}

export function getAuthToken(): string | null {
	return appStore.getState().authToken;
}

export function authTokenExists(): boolean {
	return appStore.getState().authToken != null;
}
